<template>
  <section
    :id="`${cms.scroll_id}`"
    v-editable="cms"
    :class="[name]"
    :style="mainCssVars"
  >
    <grid
      :class="[
        { 'grid--container': !fullwidth },
        `${name}__grid`,
        cms.style_grid,
      ]"
      :layout="[
        {
          size: 1,
          columns: 'repeat(12, 1fr)',
          gap: '0 6px',
        },
        {
          size: 2,
          columns: 'repeat(24, 1fr)',
          gap: '10px',
        },
      ]"
    >
      <grid-item
        :class="[
          `${name}__grid-item`,
          `${name}__grid-content`,
          `${name}__column-one`,
        ]"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 3, x: 1, width: 24 },
        ]"
      >
        <component
          :is="item.component"
          v-for="item in cms.column_one"
          :key="item._uid"
          v-editable="item"
          :cms="item"
          :class="`${name}__content`"
        />
      </grid-item>
      <grid-item
        :class="[
          `${name}__grid-item`,
          `${name}__grid-content`,
          `${name}__column-two`,
        ]"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 3, x: 1, width: 24 },
        ]"
      >
        <component
          :is="item.component"
          v-for="item in cms.column_two"
          :key="item._uid"
          v-editable="item"
          :cms="item"
          :class="`${name}__content`"
        />
      </grid-item>
    </grid>
  </section>
</template>

<script>
import Colors from '~/mixins/colors'
import data from '~/components/organisms/o-article-v2/o-article-v2.data'

export default {
  mixins: [Colors],
  props: {
    cms: {
      type: Object,
      default() {
        const config = {}
        return process.env.NODE_ENV === 'development'
          ? { ...data, ...config }
          : config
      },
    },
  },

  data() {
    return {
      name: 'o-article-v3',
    }
  },

  computed: {
    spacing() {
      return this.cms.spacing
    },
    fullwidth() {
      return this.cms.fullwidth || false
    },
    mainCssVars() {
      return {
        '--bg-color': this.setColor(
          (this.cms.color_background || {}).color || '#FFFFFF',
          this.cms.color_gradient
        ),
        '--text-color': this.setColor(
          (this.cms.color_text || {}).color || '#000000'
        ),
        '--hover-color': this.setColor(
          (this.cms.color_hover || {}).color || '#C33CA8'
        ),
        '--disabled-color': this.setColor(
          (this.cms.color_disabled || {}).color || '#888b8d'
        ),
        '--spacing-top': this.cms.spacing_top || '100px',
        '--spacing-bottom': this.cms.spacing_bottom || '100px',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.o-article-v3 {
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
    border 0.2s ease-in-out;
  background: var(--bg-color);
  border-color: var(--text-color);
  color: var(--text-color);
  // min-height: 670px;
  padding: var(--spacing-top) 0 var(--spacing-bottom);
}
@include media-breakpoint-up(md) {
  .o-article-v3 {
    .grid_2575 {
      .o-article-v3 {
        &__column-one {
          grid-column: 1 / span 4;
        }
        &__column-two {
          grid-column: 6 / span 14;
        }
      }
    }
    .grid_7525 {
      .o-article-v3 {
        &__column-one {
          grid-column: 1 / span 14;
        }
        &__column-two {
          grid-column: 16 / span 4;
        }
      }
    }
    .grid_5050 {
      .o-article-v3 {
        &__column-one {
          grid-column: 1 / span 11;
        }
        &__column-two {
          grid-column: 13 / -1;
        }
      }
    }
  }
}
</style>
